// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PStarOutlinedSvg from "@fishx/icons-svg/es/asn/PStarOutlined";
import FishxIcon from '../components/FishxIcon';

var PStarOutlined = function PStarOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: PStarOutlinedSvg
  }));
};

PStarOutlined.displayName = 'PStarOutlined';
export default React.forwardRef(PStarOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/PStarOutlined.js
// module id = 3656
// module chunks = 0